import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=7260b114&scoped=true&lang=html&"
import script from "./AppVersion.vue?vue&type=script&lang=js&"
export * from "./AppVersion.vue?vue&type=script&lang=js&"
import style0 from "./AppVersion.vue?vue&type=style&index=0&id=7260b114&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7260b114",
  null
  
)

export default component.exports